<template>
  <section class="pa-3 ma-2 border">
    <v-row align="center">
      <v-col cols="4">
        <p class="caption"  style="height:3rem">{{ $t('bf.employee') }}</p>
        <p v-if="user" class="text-subtitle-1 font-weight-medium mb-0">{{ user.firstname }} {{ user.lastname }}</p>
      </v-col>

      <v-col cols="4">
        <p class="caption" style="height:3rem">{{ $t(completedTextKey) }}</p>
        <p class="text-subtitle-1 mb-0" >{{ ratings.length }}</p>
      </v-col>

      <v-col cols="4">
        <p class="caption" style="height:3rem">{{ $t(openTextKey) }}</p>
        <p class="text-subtitle-1 mb-0">{{ openRatings.length }}</p>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import index from '@/modules/begleitfahrt';
import configMixin from '@/mixins/configMixin';
import common from '@/mixins/common';

export default {
  name: 'RatingOverview',
  mixins: [common, configMixin],
  props: {
    user: Object,
    openRatings: Array,
    ratings: Array,
  },
  computed: {
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.mx_instance);
    },
    completedTextKey() {
      return this.moduleConfig.enableDiscussions ? 'bf.completed.assessmentAndEvaluations' : 'bf.completed.assessment';
    },
    openTextKey() {
      return this.moduleConfig.enableDiscussions ? 'bf.open.assessmentAndEvaluations' : 'bf.open.assessment';
    },
  },
};
</script>
